export const quotationTemplate =
    `Date: ___________
 
Dear $client_name,
 
Greetings from $company_name!

It was great to have a discussion on the different plans that $company_name provides. Thank you for allowing us to propose our$plan_name. The services cover important areas of your personal finance such as $service_name.
 
We recommend you the following segments of financial planning after prudently analysing your data:
$service_fee

Service quotation terms:
 This quotation will be valid for 15 days from the date of this Statement of Work.
 We agree to keep confidential all the information received from you during the financial plan and execution of the agreed services.
Our fees will only include the $plan_name mentioned above. 
The above fees are one-time annual charges valid for 12 months from the date of the plan. 
Extra fees will be charged for other matters not included herein. 
We will need your utmost cooperation in providing the required information to enable us to render you the services agreed upon. 
Payment terms would be as per invoice.
`;
